var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'is-small': _vm.window.width < 1200},attrs:{"id":"app"}},[_c('com-pdf'),_c('com-sidebar'),_c('com-map'),_c('com-toggle'),_c('com-key'),_c('com-prompt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }